export const PARTNER = 0;

const getIndependenceType = (independenceType) => independenceType === null ? PARTNER : independenceType;

export default getIndependenceType;